/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Kpi_Skus_HintInputs */

const vi_warehouse_sales_kpi_skus_hint = /** @type {(inputs: Warehouse_Sales_Kpi_Skus_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm đang quản lý`)
};

/**

* @param {Warehouse_Sales_Kpi_Skus_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_kpi_skus_hint = /** @type {((inputs?: Warehouse_Sales_Kpi_Skus_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Kpi_Skus_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_kpi_skus_hint(inputs)
});